









import { defineComponent } from '@nuxtjs/composition-api'

export default defineComponent({
  name: 'NavigationSectionSubpageStepback',
  props: {
    label: {
      type: String,
      required: true,
    },
  },
})
